module.exports = __webpack_public_path__ + "img/1587070423.7b89db30.jpg";